import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIUser extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getUserId = async (
    userId: UUID,
    { page, size }: { page?: number | null; size?: number | null } = {},
  ): Promise<types.PageMessageResponse> => {
    let res = await this._fetch({
      url: `/messages/user/${userId}`,
      method: "GET",
      params: { page: page, size: size },
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
